import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import ModalUserData from "../../modal/user/modalUserData";
import ModalCharge from "../../modal/modalCharge";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { postBanco } from "../../services/banco.services";

const Banco = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const initialValues = {
    id_usuario: "",
    nombre: "",
    horas: "",
    permiso_fecha: dayjs(),
  };

  const checkoutSchema = yup.object().shape({
    id_usuario: yup.number().required("Este campo es requerido"),
    horas: yup.number().required("Este campo es requerido"),
    permiso_fecha: yup.date().required("Seleccione una fecha"),
  });

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    try {
      // Convertir horas ingresadas a minutos para almacenar en BD
      const horasNumber = Number(values.horas || 0);
      const minutos = Math.round(horasNumber * 60);
      const dataToSend = {
        id_usuario: values.id_usuario,
        minutos: minutos, // el backend mantiene el campo "horas" pero ahora enviamos minutos
        deber_fecha: values.permiso_fecha.format("YYYY-MM-DD"),
      };

      await postBanco(dataToSend);

      setRegistrationSuccess(true);
      resetForm();
    } catch (error) {
      console.error("Error saving permiso:", error);
      setError(error.message || "Error desconocido");
      setRegistrationError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box m="20px">
      <Header title="Registro Banco de Tiempo" subtitle="Registrar banco de tiempo" />

      {isLoading && <ModalCharge isLoading={true} />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />
      )}
      {registrationError && (
        <ModalError open={registrationError} onClose={() => setRegistrationError(false)} error={error} />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                label="Usuario"
                name="id_usuario"
                value={values.nombre || ""}
                onClick={() => setIsModalOpen(true)}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.id_usuario && !!errors.id_usuario}
                helperText={touched.id_usuario && errors.id_usuario}
                sx={{ gridColumn: "span 1", cursor: "pointer" }}
                InputProps={{ readOnly: true }}
              />

              <TextField
                fullWidth
                variant="filled"
                label="Horas (puede usar decimales)"
                name="horas"
                value={values.horas || ""}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.horas && !!errors.horas}
                helperText={touched.horas && errors.horas}
                sx={{ gridColumn: "span 1", cursor: "pointer" }}
              />

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Fecha Banco de Hora"
                  value={values.permiso_fecha}
                  onChange={(newValue) => setFieldValue("permiso_fecha", newValue)}
                  slotProps={{
                    textField: {
                      variant: "filled",
                      fullWidth: true,
                      error: !!touched.permiso_fecha && !!errors.permiso_fecha,
                      helperText: touched.permiso_fecha && errors.permiso_fecha,
                      sx: { gridColumn: "span 2" },
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained" disabled={isLoading}>
                Registrar
              </Button>
            </Box>

            {isModalOpen && (
              <ModalUserData
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSelectUsuario={(usuario) => {
                  setFieldValue("id_usuario", usuario.id);
                  setFieldValue("nombre", usuario.firstname + " " + usuario.lastname);
                  setIsModalOpen(false);
                }}
              />
            )}
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default Banco;